import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useBankAccountReasonService from '../../../app/services/hooks/useBankAccountReasonService';
import { BankAccountReason } from '../../../app/models/BankAccountReason';
import BankAccountReasonFormContainer from './BankAccountReasonFormContainer';

interface Props {
    bankAccountReasonId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BankAccountReasonEdit = ({ bankAccountReasonId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const {
        fetchingEditBankAccountReason,
        editBankAccountReason,
        fetchingUpdateBankAccountReason,
        updateBankAccountReason
    } = useBankAccountReasonService();
    const [bankAccountReason, setBankAccountReason] = useState<BankAccountReason>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        editBankAccountReason(bankAccountReasonId, {
            onSuccess: (response: ServiceResponse) => {
                const data = response.data?.bank_account_reason;
                setBankAccountReason({
                    id: data?.id,
                    name: data?.name ?? '',
                    is_active: data?.is_active
                });
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, [bankAccountReasonId]);

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando motivo de cuenta...');
        updateBankAccountReason(bankAccountReasonId, bankAccountReason, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
            },
            onFieldError: (res: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(res.data);
            }
        });
    };

    return fetchingEditBankAccountReason ? (
        <LazyLoading height={300} />
    ) : (
        <BankAccountReasonFormContainer
            fetching={fetchingUpdateBankAccountReason}
            action={update}
            cancel={() => onCancel?.()}
            bankAccountReason={bankAccountReason}
            setBankAccountReason={setBankAccountReason}
            errorFields={errorFields}
        />
    );
};

export default BankAccountReasonEdit;
